// ============================================================================
// HAI Reporting Tool - Admin Access Hook
// Check if current user has admin privileges
// ============================================================================

import { useAuth } from '@/contexts/AuthContext';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export function useAdminAccess(redirectOnFail: boolean = true) {
  const { userProfile } = useAuth();
  const navigate = useNavigate();

  const isAdmin = userProfile?.role === 'Admin';

  useEffect(() => {
    if (redirectOnFail && userProfile && !isAdmin) {
      navigate('/dashboard');
    }
  }, [userProfile, isAdmin, redirectOnFail, navigate]);

  return { isAdmin, userProfile };
}
